module.exports = __webpack_public_path__ + "static/media/dust.3f23f463.mp4";